import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "./BoxImgTPB.css";

// Web Component
export function BoxImgTPB({ ImgSrc, ImgAlt, Heading, Paragraph, ButtonText, ButtonImg, ButtonLink, TopHeight, HeadArFont, ArFont }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  return (
    <div className="BoxImgTPB_Container">
      <div>
        <img src={ImgSrc} alt={ImgAlt} className="BoxImgTPBImg" />
      </div>
      <div className="BoxImgTPBH" style={{ fontFamily: HeadArFont }}>
        {Heading}
      </div>
      <div className="BoxImgTPBP" style={{ top: TopHeight, fontFamily: ArFont }} dir={isArabic ? "rtl" : ""}>
        {Paragraph}
      </div>
      <div className="BoxImgTPB_Button" dir={isArabic ? "rtl" : ""}>
        <Link to={ButtonLink} className="BoxImgTPB_ButtonC">
          <div className="BoxImgTPB_ButtonC_Text" style={{ fontFamily: ArFont }}>
            {ButtonText}
          </div>
          <div className="BoxImgTPB_ButtonC_Img_Icon">
            <img src={ButtonImg} alt="" className="BoxImgTPB_ButtonC_Img" style={{ rotate: isArabic ? "180deg" : "" }} />
          </div>
        </Link>
      </div>
    </div>
  );
}

// Mobile Component
export function BoxImgTPBMobile({ ImgSrc, ImgAlt, Heading, Paragraph, ButtonText, ButtonImg, ButtonLink, TopHeight, HeadArFont, ArFont }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  return (
    <div className="BoxImgTPB_Container_Mob">
      <div>
        <img src={ImgSrc} alt={ImgAlt} className="BoxImgTPBImg_Mob" />
      </div>
      <div className="BoxImgTPBH_Mob" style={{ fontFamily: HeadArFont }}>
        {Heading}
      </div>
      <div className="BoxImgTPBP_Mob" style={{ top: TopHeight, fontFamily: ArFont }} dir={isArabic ? "rtl" : ""}>
        {Paragraph}
      </div>
      <div className="BoxImgTPB_Button_Mob">
        <Link to={ButtonLink} className="BoxImgTPB_ButtonC_Mob" dir={isArabic ? "rtl" : ""}>
          <div className="BoxImgTPB_ButtonC_Text_Mob" style={{ fontFamily: ArFont }}>
            {ButtonText}
          </div>
          <div className="BoxImgTPB_ButtonC_Img_Icon">
            <img src={ButtonImg} alt="" className="BoxImgTPB_ButtonC_Img_Mob" style={{ rotate: isArabic ? "180deg" : "" }} />
          </div>
        </Link>
      </div>
    </div>
  );
}

// Wrapper Component
export default function ResponsiveBoxImgTPB(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <BoxImgTPBMobile {...props} /> : <BoxImgTPB {...props} />;
}
